import academicApi from '@/services/plataforma/academic';

export default {
  getAll({ commit }, { isEnrolled, filterByIsActive }) {
    return academicApi.getAllRoles({ isEnrolled, filterByIsActive })
      .then((res) => {
        commit('SET_ROLES', res.data.roles);
        return res.data;
      });
  },
  getDefaultRoles() {
    return academicApi.getDefaultRoles()
      .then((response) => {
        return Promise.resolve(response.data.roles);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error);
      });
  }
};
